import React, { useState, useMemo, useEffect, useRef, ReactNode } from 'react';
import { useParams } from 'react-router-dom';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { Config } from '@/config';
import {
  errorModalTextRecoil,
  completeModalRecoil,
  deleteModalRecoil,
} from '@/atom/ModalAtom';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import LS from '@/styles/layoutStyled';
import CS from '@/styles/componentStyled';
import BS from '@/styles/btnStyled';
import IS from '@/styles/inputStyled';
import { FacilityApi } from '@/sdk/FacilityApi';
import { FacilityDeviceDtoRx } from '@/sdk/data-contracts';
import { facilitiesLocationInforListRecoil } from '@/atom/FacilitiesAtom';
import { Map, MapMarker } from 'react-kakao-maps-sdk';

declare global {
  interface Window {
    kakao: any;
  }
}

const LocationInfor = () => {
  const { id } = useParams<{ id: string }>();
  const facilityApi = new FacilityApi({ baseURL: Config.API_URL });
  const navigate = useNavigate();

  const setErrorModalText = useSetRecoilState(errorModalTextRecoil);
  const setCompleteModalState = useSetRecoilState(completeModalRecoil);
  const [deleteModalState, setDeleteModalState] =
    useRecoilState(deleteModalRecoil);
  const [
    facilitiesLocationInforListState,
    setFacilitiesLocationInforListState,
  ] = useRecoilState(facilitiesLocationInforListRecoil);
  const [selectedMarkerIndex, setSelectedMarkerIndex] = useState<number>(0);
  const [selectDevice, setSelectDevice] = useState<FacilityDeviceDtoRx>();

  const getOffsetPosition = (
    latitude: number,
    longitude: number,
    index: number,
  ) => {
    const offset = index * 3;
    return { lat: latitude + offset * 1e-5, lng: longitude + offset * 1e-5 };
  };

  const filterLocationInforList = async () => {
    try {
      const { data } = await facilityApi.facilityControllerGetLocation(
        Number(id),
        {
          headers: {
            Authorization: `Bearer ${String(sessionStorage.getItem('accessToken'))}`,
            'Content-Type': 'application/json',
          },
        },
      );
      if (data.devices) setFacilitiesLocationInforListState(data.devices);
      setSelectDevice(data.devices[data.devices.length - 1]);
      setSelectedMarkerIndex(data.devices.length - 1);
    } catch (err: any) {}
  };

  useEffect(() => {
    filterLocationInforList();
  }, []);

  return (
    <>
      {facilitiesLocationInforListState.length !== 0 && (
        <TabCntBox>
          <MapBox>
            <Map
              center={
                selectDevice?.latitude && selectDevice?.longitude
                  ? { lat: selectDevice.latitude, lng: selectDevice.longitude }
                  : { lat: 33.450701, lng: 126.570667 }
              }
              style={{ width: '100%', height: '100%' }}
              level={3}
              draggable={true}
              zoomable={true}
            >
              {facilitiesLocationInforListState.map((list, index) => {
                const position = getOffsetPosition(
                  list.latitude,
                  list.longitude,
                  index,
                );

                return (
                  <MapMarker
                    key={index}
                    position={{ lat: position.lat, lng: position.lng }}
                    image={{
                      src:
                        selectedMarkerIndex === index
                          ? '/img/ico_marker_red.svg'
                          : '/img/ico_marker_blue.svg',
                      size: { width: 28, height: 28 },
                    }}
                    onClick={() => {
                      setSelectedMarkerIndex(index);
                      setSelectDevice(list);
                    }}
                  />
                );
              })}
            </Map>
            <MapModal>
              <div className="title-box">
                <h1>{selectDevice?.deviceName}</h1>
              </div>
              <div className="text-box">
                <div className="state-box">
                  <span className="text">
                    {selectDevice?.communicationStatus}
                  </span>
                  <span className="line"></span>
                  <span className="text">{selectDevice?.sensorStatus}</span>
                </div>
                <span className="date">{selectDevice?.lastDataReceivedAt}</span>
                <button
                  onClick={() =>
                    navigate(`/device/detail/${selectDevice?.deviceId}`)
                  }
                >
                  디바이스 상세
                </button>
              </div>
            </MapModal>
          </MapBox>
        </TabCntBox>
      )}
    </>
  );
};

export default LocationInfor;

export const CntBox1 = styled(CS.CntBoxType1)`
  width: 100%;
`;

export const CntBox2 = styled(CS.CntBoxType1)`
  width: 100%;
  margin-top: 20px;
`;

export const InforWrap = styled.div`
  width: 100%;
  display: flex;
  gap: 20px;
  margin-top: 16px;
`;

export const InforBox1 = styled(CS.CntBoxType2)`
  position: relative;
  width: calc(50% - 13.3333px);
  > .device-btn {
    position: absolute;
    right: 20px;
    bottom: 20px;
  }
`;

export const InforBox2 = styled(CS.CntBoxType2)`
  width: calc(25% - 13.3333px);
  > .text-wrap {
    &:before {
      display: none;
    }
    > .text-box {
      width: 100%;
      &:first-child {
        padding-right: 0;
      }
      &:last-child {
        padding-left: 0;
      }
    }
  }
`;

export const InforBox3 = styled(CS.CntBoxType2)`
  width: calc(25% - 13.3333px);
  > .img-area {
    width: 100%;
    position: relative;
    margin-top: 12px;
    > button {
      position: absolute;
      width: 34px;
      height: 34px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      border: 1px solid #ececec;
      background: #fff;
      border-radius: 4px;
      left: 10px;
      bottom: 10px;
      > .img-box {
        width: 24px;
      }
    }
  }
`;

export const SearchOptionBox = styled(CS.SearchOptionBox)`
  width: 100%;
  margin-top: 20px;
`;

export const InputWrap = styled.div`
  gap: 8px;
  display: flex;
  flex-direction: column;
`;

export const InputArea = styled.div`
  gap: 8px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  > h2 {
    color: #555;
    font-size: 14px;
  }
`;

export const TabCntBox = styled.div`
  width: 100%;
  margin-top: 20px;
`;

export const TableOpitonBox = styled(CS.TableOpitonBox)`
  width: 100%;
  margin-top: 20px;
`;

export const TableOpitonBox2 = styled(TableOpitonBox)`
  margin-top: 32px;
`;

export const TableBox = styled(CS.TableType1)`
  width: 100%;
  margin-top: 16px;
  margin-bottom: 32px;
`;

export const MapBox = styled.div`
  width: 100%;
  height: 400px;
  position: relative;
  border-radius: 12px;
  overflow: hidden;
`;

export const MapModal = styled.div`
  position: absolute;
  z-index: 10;
  top: 50%;
  right: 25%;
  transform: translateY(-50%);
  width: 180px;
  border-radius: 4px;
  box-sizing: border-box;
  border: 1px solid #d9d9d9;
  box-shadow: 4px 4px 12px 0px rgba(255, 255, 255, 0.25);
  overflow: hidden;
  > .title-box {
    box-sizing: border-box;
    padding: 8px 12px;
    background: #e9e8e8;
    font-size: 16px;
    font-weight: 500;
  }
  > .text-box {
    box-sizing: border-box;
    padding: 12px;
    background: #fff;
    > .state-box {
      display: flex;
      align-items: center;
      gap: 8px;
      > .text {
        font-size: 15px;
      }
      > .line {
        width: 1px;
        height: 10px;
        background: #d9d9d9;
      }
    }
    > .date {
      margin-top: 6px;
      font-size: 12px;
      font-weight: 300;
      color: #777;
    }
    > button {
      margin-top: 8px;
      font-size: 14px;
      color: #3c8deb;
    }
  }
`;
